import type {ProMapPolygon} from '../../../types';

import {Map, Polygon} from '@Map';
import MapMarkerIcon from 'assets/images/map/vendor-pin.svg';
import {FullscreenControl, Marker} from 'react-map-gl/maplibre';

import {PRO_MAP_LEGEND_CLIP_PATH} from '../../../constants';

type ProCoverageMapProps = {
  latitude: number;
  longitude: number;
  polygons: ProMapPolygon[];
  selectedPolygonIds: Array<string | number>;
};

const ProCoverageMap: React.FC<ProCoverageMapProps> = ({
  latitude,
  longitude,
  polygons,
  selectedPolygonIds
}) => {
  return (
    <div className="relative mt-4 h-75 overflow-hidden rounded-lg">
      <div className="absolute top-2 right-2 z-10 flex items-center gap-2">
        <div className="flex h-8 items-center justify-center gap-1.5 rounded-md bg-white px-4 text-body-sm-emphasis text-neutral-fg">
          <span
            className="size-4 border border-orange bg-orange/20"
            style={{clipPath: PRO_MAP_LEGEND_CLIP_PATH}}
            aria-hidden
          />
          منطقه پوشش‌دهی
        </div>
      </div>
      <Map centerLat={latitude} centerLong={longitude} zoom={12}>
        <Marker longitude={longitude} latitude={latitude}>
          <img className="size-20" src={MapMarkerIcon} alt="موقعیت فروشگاه" />
        </Marker>
        <FullscreenControl position="bottom-left" />
        {polygons.length > 0 ? (
          <Polygon data={polygons} selectedPolygonIds={selectedPolygonIds} />
        ) : null}
      </Map>
    </div>
  );
};

export default ProCoverageMap;
